import { Spinner } from "@shadcn/components/ui/spinner"

export function CenteredStatus({ isLoading = true, children }: { isLoading?: boolean; children?: React.ReactNode }) {
	return (
		<div className="flex h-full min-h-[80vh] w-full items-center justify-center gap-2">
			{isLoading && <Spinner />}
			<div className="flex flex-col items-center justify-center gap-2.5">{children}</div>
		</div>
	)
}
